<template>
  <el-card >
    <!-- 查询表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="安全措施:" >
        <el-input v-model="searchFactor.safeManageOption"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateSafeManage">创建</el-button>
      </el-form-item>
    </el-form>
    <!-- 角色表格 -->
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 90%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="safeManageOption"
        label="安全措施"
        min-width="150px">
      </el-table-column>
      <el-table-column
        prop="detail"
        min-width="200px"
        label="详情" >
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="150px">
      </el-table-column>
      <el-table-column
        prop="updateUser"
        width="120"
        label="更新者">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        min-width="150px"
        label="更新时间">
      </el-table-column>
      <el-table-column label="操作" min-width="120px" >
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"delete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除安全措施</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"edit",index:scope.$index, data:scope.row}'><i class="el-icon-document" style="color:rgb(40, 238, 10)" ></i> <span>修改安全措施</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
     <!-- 分页组件 -->
     <el-pagination
        background
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="pager.pageSize"
        :total="pager.totalCount" style="margin:10px">
    </el-pagination>
    <!-- 修改权限弹框 -->
    <el-dialog :visible.sync="dialogVisual.editSafeManageDialogVisible" v-on:close ="clearEditSafeManageInfoForm" >
      <div slot="title" class="dialog-footer">
        <span> 安全措施[{{ editSafeManageForm.safeManageOption }}] 信息变更 </span>
      </div>
      <el-form :model="editSafeManageForm" label-width="20%"> 
        <el-form-item label="角安全措施:"  style="width: 80%">
          <el-input v-model="editSafeManageForm.safeManageOption" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="详情:" style="width: 80%">
          <el-input type="textarea" v-model="editSafeManageForm.detail" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureChange">确定变更</el-button>
      </div>
    </el-dialog>
    <!-- 创安全措施弹框 -->
    <el-dialog :visible.sync="dialogVisual.createSafeManageDialogVisible" v-on:close ="clearCreateSafeManageInfoForm" >
      <div slot="title" class="dialog-footer">
        <span> 创建安全措施信息 </span>
      </div>
      <el-form :model="createSafeManageForm" label-width="20%"> 
        <el-form-item label="安全措施:" style="width: 80%" >
          <el-input v-model="createSafeManageForm.safeManageOption" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="详情:" style="width: 80%">
          <el-input type="textarea" v-model="createSafeManageForm.detail" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建安全措施</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty} from  '@/api/utils'
import {MESSAGE_DURATION,PAGE_SIZE} from  '@/api/constant'
export default {
  name : 'pc_ctr_sage_manage',
  data() {
    return {
      searchFactor:{
        safeManageOption :""
      },
      tableData: [],
      dialogVisual:{
        editSafeManageDialogVisible: false,
        createSafeManageDialogVisible: false
      },
      editSafeManageForm: {
        safeManageOption: '',
        detail: '',
        id :''
      },
      createSafeManageForm: {
        safeManageOption: '',
        detail: ''
      },
      pager:{
        totalCount:0,
        pageSize : PAGE_SIZE
      }
    }
  },
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'delete' :
          this.handleDelete(index,row)
          break
        case 'edit' :
          this.handleEdit(index,row)
          break
      }
    },
    indexMethod(index){
      return  index + 1
    },
    safeManageListLoad(pageNo){
      let url = "/bc/exa/safeManage/safeManagePage"
      let { 
        safeManageOption
      } = this.searchFactor 
      let dat0 = {
        pageSize: PAGE_SIZE,
        safeManageOption,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.tableData = [];
            dat.data.forEach(t=>this.tableData.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全措施信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    clearEditSafeManageInfoForm(){
      this.editSafeManageForm.safeManageOption = ''
      this.editSafeManageForm.detail = ''
      this.editSafeManageForm.id = ''
    },
    clearCreateSafeManageInfoForm(){
      this.createSafeManageForm.safeManageOption = ''
      this.createSafeManageForm.detail = ''
    },
    onSearch(){
      this.safeManageListLoad(1)
    },
    handleEdit(index, row){
      this.dialogVisual.editSafeManageDialogVisible = true
      this.editSafeManageForm.safeManageOption = row.safeManageOption
      this.editSafeManageForm.detail = row.detail
      this.editSafeManageForm.id = row.id
    },
    handleCreateSafeManage(){
      this.dialogVisual.createSafeManageDialogVisible = true
    },
    ensureChange(){
      this.$confirm('即将更新安全措施['+this.editSafeManageForm.safeManageOption+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doChangeSafeManageInfo()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消更新！'
        });
      })
    },
    doChangeSafeManageInfo(){
      let url = "/bc/exa/safeManage/safeManageEdit"
      let s = JSON.stringify(this.editSafeManageForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.editSafeManageDialogVisible= false;
          this.clearEditSafeManageInfoForm();
          this.$message({
            showClose: true,
            message: '更新成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.safeManageListLoad(1)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    ensureCreate(){
      try{ 
        stringIsNullOrEmpty(this.createSafeManageForm.safeManageOption,'请输安全措施!');
        stringIsNullOrEmpty(this.createSafeManageForm.detail,'请输入安全管理措施详情!');
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doCreateSafeManageInfo();
    },
    doCreateSafeManageInfo(){
      let url = "/bc/exa/safeManage/safeManageCreate"
      let s = JSON.stringify(this.createSafeManageForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.createSafeManageDialogVisible = false
          this.clearCreateSafeManageInfoForm()
          this.$message({
            showClose: true,
            message: '创建成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.safeManageListLoad(1)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }, 
    handleDelete(index, row){
      this.$confirm('即将删除安全措施['+row.safeManage+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteSafeManage(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteSafeManage(row){
      let dat = {id: row.id}
      let url = "/bc/exa/safeManage/safeManageDelete"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.safeManageListLoad(1)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleCurrentChange(val){
      this.safeManageListLoad(val)
    },
  },
  created () {
    this.safeManageListLoad(1)
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

.text {
  font-size: 14px;
  color: #000;
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_safe_manage.vue